import { render, staticRenderFns } from "./ClientClaim.vue?vue&type=template&id=41b62922&"
import script from "./ClientClaim.vue?vue&type=script&lang=js&"
export * from "./ClientClaim.vue?vue&type=script&lang=js&"
import style0 from "./ClientClaim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports